module.exports = __webpack_public_path__ + "media/images/logo-74eb0ebfd0ae06387cbc4fde08578461.svg";